import React from "react";
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {useUserTableActions} from "../@hooks";
import { userDrawerFilters } from "../../@signals";


export default function simpleValueColumn(name, label, showActions=false) {
    return {
        name: name, label: label,
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: (value, row) => <OptionsCell
                value={value}
                row={row}
                showActions={showActions}
            />
        }
    }
}

const OptionsCell = ({ value, row, showActions} ) => {
    const { deleteRow, sendCredentials } = useUserTableActions()

    return <Box>
        {value}
        {!!showActions && <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
            <IconSeeker
                icon="trash"
                tooltip="Delete user"
                sx={{ fontSize: '1rem', cursor: 'pointer'  }}
                onClick={() => deleteRow(row)}
            />
            <IconSeeker
                icon="pen"
                tooltip="Modify user"
                sx={{ ml: 2, fontSize: '1rem', cursor: 'pointer'  }}
                onClick={() => userDrawerFilters.value = row}
            />
            <IconSeeker
                icon="paper-plane"
                tooltip={row.email ? "Send credentials by email" : "User has no email address"}
                sx={{ ml: 2, fontSize: '1rem', cursor: row.email ? 'pointer' : 'not-allowed', opacity: row.email ? 1 : 0.4 }}
                onClick={() => row.email && sendCredentials(row)}
            />
        </Box>}
    </Box>
}